import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "account-page-body" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "account-avatar-circle" }
const _hoisted_5 = {
  class: "account-avatar-camera",
  "aria-hidden": "true"
}
const _hoisted_6 = { class: "ion-text-center account-username" }
const _hoisted_7 = { class: "account-info ion-margin-top" }
const _hoisted_8 = { class: "account-item" }
const _hoisted_9 = { class: "account-item-value" }
const _hoisted_10 = { class: "account-item" }
const _hoisted_11 = { class: "account-item-value" }
const _hoisted_12 = { class: "account-item" }
const _hoisted_13 = { class: "account-item-value" }
const _hoisted_14 = { class: "account-item account-item-input" }
const _hoisted_15 = { class: "account-item account-item-input" }
const _hoisted_16 = { class: "account-item account-item-icon" }
const _hoisted_17 = { class: "account-item account-item-privacy" }
const _hoisted_18 = {
  key: 0,
  class: "account-item account-item-consent"
}
const _hoisted_19 = { class: "account-item-value" }
const _hoisted_20 = { class: "account-sessions-block" }
const _hoisted_21 = { class: "account-sessions-title" }
const _hoisted_22 = {
  key: 0,
  class: "account-sessions-hint"
}
const _hoisted_23 = {
  key: 1,
  class: "account-sessions-list"
}
const _hoisted_24 = { class: "account-session-info" }
const _hoisted_25 = { class: "account-session-device" }
const _hoisted_26 = { class: "account-session-date" }
const _hoisted_27 = {
  key: 2,
  class: "account-sessions-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: _normalizeClass([_ctx.isMobile ? 'main-background account-content' : 'liga-web-background account-content account-content--web']),
        fullscreen: true,
        "scroll-y": true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                src: _ctx.accountLogoSrc,
                alt: "liga-logo"
              }, null, 8, _hoisted_3)
            ]),
            _cache[20] || (_cache[20] = _createElementVNode("h1", { class: "ion-text-center account-page-title" }, "ЛИЧНЫЙ КАБИНЕТ", -1)),
            _createElementVNode("div", {
              class: "account-avatar-wrap",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadAvatar())),
              title: "Изменить фото"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_ion_avatar, { class: "account-avatar" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_img, { src: _ctx.displayAvatarSrc }, null, 8, ["src"])
                  ]),
                  _: 1
                }),
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_ion_icon, { icon: _ctx.cameraOutline }, null, 8, ["icon"])
                ])
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "account-avatar-change" }, "Изменить", -1))
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.lastname) + " " + _toDisplayString(_ctx.firstname), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "account-item-label" }, "Логин", -1)),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.username), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "account-item-label" }, "E-mail", -1)),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.email), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "account-item-label" }, "Телефон", -1)),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.phoneDisplay), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_ion_input, {
                  label: "Имя",
                  "label-placement": "stacked",
                  type: "text",
                  maxlength: "50",
                  modelValue: _ctx.firstname,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.firstname) = $event)),
                  placeholder: "Имя"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_ion_input, {
                  label: "Фамилия",
                  "label-placement": "stacked",
                  type: "text",
                  maxlength: "50",
                  modelValue: _ctx.lastname,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lastname) = $event)),
                  placeholder: "Фамилия"
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_component_ion_button, {
                class: "account-save-btn",
                disabled: _ctx.savingProfile || !_ctx.canSaveProfile,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveProfile()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.savingProfile ? 'Сохранение…' : 'Сохранить'), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createElementVNode("div", _hoisted_16, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "account-item-label" }, "Пароль", -1)),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "account-item-value" }, "******", -1)),
                _createVNode(_component_ion_icon, {
                  icon: _ctx.keyOutline,
                  class: "password-icon",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changePassword()))
                }, null, 8, ["icon"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "account-item-label" }, "Политика конфиденциальности", -1)),
                _createVNode(_component_ion_button, {
                  fill: "outline",
                  size: "small",
                  class: "privacy-link-btn",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/privacy-policy')))
                }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode(" Открыть ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              (_ctx.privacyConsentAccepted !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "account-item-label" }, "Согласие с условиями", -1)),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.privacyConsentAccepted ? 'Принято' : 'Не принято'), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, "Авторизации на устройствах (" + _toDisplayString(_ctx.sessions.length) + ")", 1),
                (_ctx.sessionsLoading)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_22, "Загрузка…"))
                  : (_ctx.sessions.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sessions, (s) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: s.id,
                            class: "account-session-item"
                          }, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("span", _hoisted_25, _toDisplayString(s.deviceName || 'Устройство'), 1),
                              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.formatSessionDate(s.createdAt)), 1)
                            ]),
                            _createVNode(_component_ion_button, {
                              fill: "outline",
                              size: "small",
                              class: "account-session-revoke",
                              onClick: ($event: any) => (_ctx.revokeSession(s.id))
                            }, {
                              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                _createTextVNode(" Выйти с устройства ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_27, "Нет активных авторизаций"))
              ]),
              _createVNode(_component_ion_button, {
                class: "account-signout-btn",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.signOut()))
              }, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                  _createTextVNode("Выход", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_button, {
                fill: "outline",
                class: "delete-account-button",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.confirmDeleteAccount()))
              }, {
                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                  _createTextVNode(" Удалить аккаунт ", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}